module.exports = __webpack_public_path__ + "img/star1.8063df85.svg";